module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_5.8cce69aa.png";